import * as domUtils from '@/shared/domUtils.js'

export default {

  data () {
    return {
      isExpanded: false,
      expandableExcludeClasses: []
    }
  },

  watch: {
    isExpanded (state) {
      this.$emit('update-expand-state', state)
      this.setCloseHandler(state)
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.setCloseHandler(this.isExpanded)
    })
  },

  beforeDestroy () {
    this.setCloseHandler(false)
  },

  methods: {

    toggleExpandState (state) {
      this.isExpanded = state !== undefined ? !!state : !this.isExpanded
    },

    setCloseHandler (state) {
      document.removeEventListener('click', this.onDocumentClick)
      document.removeEventListener('keyup', this.onKeyUp)
      if (state) {
        // to prevent closing component the same click it was open
        setTimeout(() => {
          document.addEventListener('click', this.onDocumentClick)
          document.addEventListener('keyup', this.onKeyUp)
        }, 0)
      }
    },

    onKeyUp (e) {
      if (e.keyCode === 27) {
        this.toggleExpandState(false)
      }
    },

    onDocumentClick (e) {
      const targetParents = domUtils.getParents(e.target, true)
      if (targetParents.some(el => el.classList && this.expandableExcludeClasses.some(c => el.classList.contains(c)))) {
        return
      }
      if (this.getExpandRoots().every(r => targetParents.indexOf(r) === -1) && !this.onAutoCollapse()) {
        this.toggleExpandState(false)
      }
    },

    getExpandRoots () {
      // Overload this method in order to provide list of elements which don't cause automatic collapse.
      return [ this.$el ]
    },

    onAutoCollapse () {
      // Overload this method in order to handle collapse caused by outer click.
      // Also you can return true in order to cancel automatic collapse.
    }
  }

}



// WEBPACK FOOTER //
// ./src/mixins/Expandable.js